export default {
  INCOME: 1,
  COST: 2,
  DEDUCTION: 2,
  INVENTORY: 3,
};
